const customMapStyles = [
	{
		"elementType": "geometry",
		"stylers": [{"color": "#f5f5f5"}]
	},
	{
		"elementType": "labels.icon",
		"stylers": [{"visibility": "off"}]
	},
	{
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#616161"}]
	},
	{
		"elementType": "labels.text.stroke",
		"stylers": [{"color": "#f5f5f5"}]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#bdbdbd"}]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{"color": "#eeeeee"}]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#757575"}]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{"color": "#e5e5e5"}]
	},
	{
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#9e9e9e"}]
	},
	{
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{"color": "#ffffff"}]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#757575"}]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{"color": "#dadada"}]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#616161"}]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#9e9e9e"}]
	},
	{
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{"color": "#e5e5e5"}]
	},
	{
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{"color": "#eeeeee"}]
	},
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{"color": "#c9c9c9"}]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#9e9e9e"}]
	}
];

function initializeAllMaps() {
	const mapContainers = document.querySelectorAll('#google-map-container');
	
	mapContainers.forEach(container => {
		const lat = parseFloat(container.dataset.lat);
		const lng = parseFloat(container.dataset.lng);
		const zoom = parseInt(container.dataset.zoom) || 15;
		const title = container.dataset.title || 'Location';
		const address = container.dataset.address || '';
		
		if (lat && lng && window.google && window.google.maps) {
			const map = new google.maps.Map(container, {
				center: { lat, lng },
				zoom: zoom,
				styles: customMapStyles,
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: true,
				zoomControl: true,
				minZoom: 10,
				maxZoom: 18
			});
			
			const createCustomMarkerIcon = () => {
				const svgMarker = {
					url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 71" fill="none" width="40" height="40">
					<style>
						.logo-path {
							fill: #691C32;
							filter: drop-shadow(0px 0px 1px white) drop-shadow(0px 0px 1px white);
						}
					</style>
					<g clip-path="url(#clip0_1524_1324)">
						<path class="logo-path" d="M89.0081 24.4023C89.1199 23.7887 88.8245 23.5162 88.3256 23.5162C86.235 23.5162 83.0605 27.878 82.117 30.1606C85.7246 29.395 88.5349 27.0148 89.0081 24.4023ZM125.812 27.4077C125.812 31.2676 124.077 34.9583 120.656 38.3794C110.871 48.1639 88.2395 54.4843 62.9982 54.4843C37.7569 54.4843 15.1252 48.1639 5.34072 38.3794C1.92244 34.9583 0.1875 31.2676 0.1875 27.4077C0.1875 12.2233 27.7774 0.331055 62.9982 0.331055C88.2395 0.331055 110.871 6.65142 120.656 16.4359C124.077 19.8571 125.812 23.5478 125.812 27.4077ZM123.787 27.4077C123.787 16.2553 105.81 5.98038 77.2535 3.04961C58.278 1.10246 43.4923 8.65019 38.3133 11.9853C36.3661 11.5666 34.3272 11.4118 32.6525 11.4118C26.7192 11.4118 20.4218 14.1676 17.3419 19.2405C13.4792 25.601 18.3112 31.2217 25.8475 23.0947C31.4022 17.1012 25.1506 12.295 21.3968 20.0549C20.8434 21.202 21.2649 21.2651 21.8958 20.1811C24.6488 15.4494 28.7094 17.583 24.6947 22.8538C19.7766 29.3089 15.4206 25.1164 19.1199 19.5302C21.9274 15.286 26.7537 11.991 32.0646 11.991C33.8712 11.991 35.6979 12.2176 37.3383 12.6477C31.7635 16.5048 27.9179 21.4458 24.6373 25.8161C22.2485 28.9992 17.9814 34.5855 14.6349 35.1819C13.6484 35.3569 12.6476 35.1361 12.1859 34.5224C12.0912 34.7288 12.1285 35.1533 12.312 35.3655C12.5501 35.6465 13.1465 35.9791 14.6377 35.9791C18.6095 35.9791 23.7397 28.5834 25.446 26.4298C28.6922 22.329 32.1506 17.2618 38.5914 13.0263C38.8725 13.1266 39.1449 13.2299 39.4087 13.3446C39.3141 13.4048 39.2195 13.465 39.1248 13.5281C32.9364 17.5572 29.1912 22.7018 25.4288 27.6342C21.5345 32.7387 17.8782 36.6961 14.6377 36.6961C12.2977 36.6961 11.1334 35.9218 11.4202 34.1668C11.4403 34.0377 11.4632 33.9058 11.5206 33.7768C12.1056 33.6793 12.9028 33.0627 13.0347 32.2483C13.1838 31.3392 12.6304 30.6596 11.5349 30.6596C10.0552 30.6596 9.14326 31.7293 8.93965 32.9652C8.50376 35.6322 11.2883 37.2295 14.2563 37.2295C19.117 37.2295 22.5783 35.5719 28.6463 28.4974C31.6287 25.0189 34.1809 21.05 37.2809 17.5801C38.2989 16.4417 39.4288 15.3061 40.5787 14.2594C41.6168 15.2917 41.7344 16.3843 41.462 18.0705C40.9056 21.4916 37.8602 23.7227 33.1113 24.4855C32.5722 24.5142 32.5435 24.7895 33.0224 24.7895C36.868 24.7895 37.9032 27.1811 37.4874 29.7391C36.9454 33.0713 33.9515 37.2667 29.8163 37.2667C28.4771 37.2667 27.7975 36.6158 27.9982 35.3884C28.1703 34.3417 28.7897 33.4384 29.9454 32.8591C29.4321 32.3888 28.7639 32.1365 27.981 32.1365C26.6504 32.1365 25.3772 33.2204 25.1793 34.4478C24.8151 36.6875 27.2698 37.6998 29.4722 37.6998C34.8262 37.6998 40.6103 35.1647 41.4706 29.8853C42.0785 26.1488 39.3084 24.5629 35.9044 24.5629C39.7643 24.2991 44.7827 22.6731 45.2387 18.4949C45.5197 15.9226 44.0228 14.2393 41.8376 13.1582C43.0679 12.1258 44.2866 11.234 45.3821 10.5945C45.8897 10.2991 45.6488 9.97505 45.2043 10.1643C43.9712 10.6948 42.3137 11.5637 40.5701 12.6219C40.2834 12.5187 39.9851 12.424 39.684 12.3352C45.8524 8.57849 57.65 3.66043 71.3317 3.66043C86.8602 3.66043 121.364 11.5035 121.364 27.4163C121.364 40.7682 95.2367 51.5908 63.0068 51.5908C30.777 51.5908 4.64387 40.7596 4.64387 27.4077C4.64387 14.0558 28.7123 4.11065 59.1412 3.28763C61.1314 2.89476 63.1875 2.58505 65.2838 2.37571C64.5267 2.36424 63.7639 2.35563 63.0011 2.35563C29.4292 2.35563 2.21208 13.5711 2.21208 27.4077C2.21208 41.2442 29.4292 52.4597 62.9982 52.4597C96.5673 52.4597 123.784 41.2442 123.784 27.4077H123.787ZM44.7598 28.2565C42.9618 30.7428 41.287 33.0971 39.5263 35.5605H42.6435C44.9204 32.2024 47.7135 28.0558 51.4644 25.6412L51.5132 25.71C50.8708 26.5502 51.0314 27.9611 52.1642 27.9611C54.1486 27.9611 56.2735 24.8755 55.5623 23.8059C55.0089 22.9714 53.5951 23.4617 52.7262 23.9894C51.6824 24.6231 49.7209 26.1717 48.0634 27.9554L48.0146 27.8866C48.0146 27.8866 50.1023 24.6518 48.9638 23.6395C47.8282 22.6301 45.0007 23.5736 43.0105 26.1688C42.6635 26.6219 42.8585 26.7882 43.2371 26.3896C44.6623 24.9042 46.2567 23.8489 46.5578 24.302C46.9364 24.8726 45.861 26.7309 44.7598 28.2508V28.2565ZM54.3235 31.973C55.548 30.2811 57.6041 27.4937 60.6009 23.6453L57.3604 23.6539C53.3141 29.1455 51.1461 31.9386 50.8163 33.7653C50.6013 34.9554 51.0945 35.9791 52.3591 35.9791C55.0089 35.9791 56.8098 33.5617 58.6193 31.8239L58.668 31.8927C58.4157 32.2684 58.1031 32.9824 57.9483 33.8341C57.7274 35.0586 58.3612 35.9791 59.5914 35.9791C61.2346 35.9791 63.133 33.9976 64.564 32.3343C63.7467 33.4413 62.981 34.4478 62.1723 35.5605H65.43C67.6009 32.1651 74.3657 23.955 76.8262 23.955C77.3968 23.955 77.6435 24.3278 77.5574 24.8038C77.1789 26.9058 72.1433 30.5707 71.5898 33.6219C71.369 34.8435 71.7303 35.9734 73.3047 35.9734C75.269 35.9734 76.8778 34.5711 78.7418 31.6289C78.7074 31.7637 78.6787 31.8984 78.6558 32.0332C78.2113 34.4851 79.3641 36.1713 81.7242 36.1713C84.7553 36.1713 87.2043 34.3016 89.4009 31.9558C89.0683 32.5838 88.8417 33.1746 88.7356 33.7567C88.4403 35.3884 89.507 35.9763 90.8032 35.9763C92.7045 35.9763 94.8983 34.293 97.1551 32.125C97.2842 32.0017 97.4132 31.8726 97.5423 31.735C97.1465 32.4462 96.8712 33.1057 96.7565 33.7567C96.4612 35.3884 97.5279 35.9763 98.8241 35.9763C100.725 35.9763 103.22 34.2327 105.534 32.125C105.626 32.0418 105.721 31.9501 105.816 31.8583C105.385 32.601 105.159 33.1803 105.053 33.7596C104.818 35.0529 105.423 35.9763 106.779 35.9763C108.25 35.9763 110.054 35.0529 112.95 32.4318C113.452 31.973 113.054 31.8612 112.589 32.2741C110.131 34.4564 108.577 35.2938 107.811 35.2938C107.433 35.2938 107.312 34.9181 107.41 34.3732C107.662 32.9767 109.833 30.3556 114.978 23.6453H111.82C109.575 26.5961 107.943 28.7325 106.922 30.1692C106.217 31.0238 105.638 31.6719 105.167 32.0906C102.868 34.1295 100.809 35.354 99.7791 35.354C99.2485 35.354 99.0105 34.9468 99.1166 34.3675C99.3547 33.0426 102.013 29.6559 106.968 22.9255H110.63L111.023 22.3032H107.424L110.811 17.8726H107.51L104.31 22.3032H99.4091L102.796 17.8726L99.478 17.8526L96.2948 22.3032H93.8975L93.5705 22.9255H95.9048C94.2215 25.2942 91.7668 28.4372 90.6971 29.937C88.4689 32.7301 86.1432 35.0299 83.7946 35.0299C82.0167 35.0299 81.2739 33.6678 81.6238 31.7264C81.6984 31.3163 81.8331 30.9091 82.0023 30.499C84.351 29.9714 90.6627 28.9562 91.3309 25.254C91.5775 23.8919 90.6656 23.1377 88.902 23.1377C84.2821 23.1377 80.8008 27.1955 79.3268 30.132C79.3211 30.1406 79.3153 30.1492 79.3096 30.1578C77.8872 32.6412 75.5873 35.2106 74.4374 35.2106C73.8667 35.2106 73.8094 34.7374 73.9958 34.1524C74.7672 31.7206 79.4673 28.3683 80.0179 25.3143C80.2387 24.0926 79.6308 23.1406 78.2715 23.1406C75.0167 23.1406 70.8413 28.1647 69.3645 29.7936L69.3157 29.7247L74.36 23.6453L70.9102 23.6567C69.4276 25.7587 66.8897 29.1168 66.2731 29.9398C65.5132 30.955 61.8741 35.1418 60.555 35.1418C60.0445 35.1418 59.7578 34.4134 61.2002 32.2282C62.6283 30.195 64.716 27.6457 67.6496 23.6481H64.5697L60.945 28.5605C58.5849 31.8067 55.3616 34.878 53.9364 34.878C53.4804 34.878 52.6201 34.3446 54.335 31.9759L54.3235 31.973ZM114.631 22.2544C115.468 22.2544 116.406 21.3683 116.572 20.4478C116.727 19.5961 116.148 18.8476 115.371 18.8476C114.439 18.8476 113.429 19.6305 113.237 20.6887C113.045 21.744 113.73 22.2544 114.631 22.2544ZM35.7754 29.4523C35.3596 32.0017 33.1543 36.1053 29.8794 36.1053C29.6414 36.1053 29.151 36.0623 28.9847 35.9333C28.5259 35.5834 28.5345 36.5412 29.8077 36.5412C33.616 36.5412 36.3002 32.5179 36.7733 29.6129C37.1174 27.5052 36.0163 24.9185 33.0138 24.9185C35.1674 25.3773 36.0679 27.66 35.7754 29.4494V29.4523ZM91.761 35.354C92.7905 35.354 94.5714 34.2184 96.7909 32.0906C97.3759 31.5285 98.024 30.7801 98.8671 29.7161C99.9196 28.2594 102.311 25.1823 103.914 22.9284H98.9503C93.995 29.6588 91.3366 33.0455 91.0986 34.3704C90.9954 34.9468 91.2334 35.3569 91.761 35.3569V35.354ZM43.1568 18.3401C43.4493 16.542 42.4685 15.1025 40.7881 14.0529C40.7737 14.0672 40.7594 14.0816 40.7422 14.093C42.1789 15.1168 42.7381 16.4675 42.4513 18.2254C41.8778 21.7354 38.6316 24.1959 33.1027 24.4769C37.0601 24.2762 42.3309 23.4073 43.1568 18.3401Z" fill="#691C32"/>
					</g>
					<defs>
						<clipPath id="clip0_1524_1324">
							<rect width="125.624" height="70" fill="white" transform="translate(0.1875 0.331055)"/>
						</clipPath>
					</defs>
				</svg>`),
					scaledSize: new google.maps.Size(60, 60),
					anchor: new google.maps.Point(20, 14),
					origin: new google.maps.Point(0, 0)
				};
				return svgMarker;
			};
			
			const infoWindow = new google.maps.InfoWindow();
			const placeUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

			const content = `
				<div class="map-info-window" style="padding: 0; margin: 0;">
					<h3 style="margin-top: 5px; margin-bottom: 5px;">${title}</h3>
					<p style="margin-top: 0; margin-bottom: 5px;">${address}</p>
					<a href="${placeUrl}" class="map-directions-link" target="_blank" rel="noopener" style="color: #691C32; text-decoration: none; font-weight: bold;">VIEW ON MAPS</a>
				</div>
			`;
			
			const marker = new google.maps.Marker({
				position: { lat, lng },
				map: map,
				title: title,
				icon: createCustomMarkerIcon(),
				animation: google.maps.Animation.DROP
			});
			
			marker.addListener('click', function() {
				infoWindow.setContent(content);
				infoWindow.open(map, marker);
			});

			infoWindow.setContent(content);
			infoWindow.open(map, marker);
		}
	});
}

function loadGoogleMapsAPI() {
	if (window.google && window.google.maps) {
		initializeAllMaps();
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', loadGoogleMapsAPI);
} else {
	loadGoogleMapsAPI();
}